<nz-header style="padding: 0; background: #fff; position: relative; z-index: 1000; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
    <app-topbar [showButtons]="false"></app-topbar>
</nz-header>
<div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: #f0f2f5; padding: 20px;">
    
    <nz-card style="width: 100%; max-width: 450px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
        
        
        <div style="text-align: center; margin-bottom: 24px;">
            <h2 nz-typography>Secure SDK Download</h2>
            @if (!hasError) {
                <p nz-typography nzType="secondary">
                    Please enter the password provided in your email to access your files.
                </p>
            }
        </div>

        @if (hasError) {
            <div style="margin-bottom: 16px; padding: 12px; background-color: #fff2f0; border: 1px solid #ffccc7; border-radius: 4px;">
                <span nz-typography nzType="danger">
                    <span nz-icon nzType="close-circle" nzTheme="outline" style="margin-right: 8px;"></span>
                    {{ errorMessage }}
                </span>
            </div>
        }

        @if (!uuid) {
            <nz-empty nzNotFoundContent="No valid token found in URL."></nz-empty>
        } @else {
            <nz-form-item>
                <nz-form-control>
                    <nz-input-password nzSize="medium">                        
                        <nz-icon nzInputPrefix nzType="lock"></nz-icon>
                        <input nz-input 
                               [(ngModel)]="password" 
                               placeholder="Enter your password" 
                               (keyup.enter)="downloadFile()" />
                    </nz-input-password>
                </nz-form-control>
            </nz-form-item>

            <button nz-button 
                    nzType="primary" 
                    nzBlock 
                    nzSize="large" 
                    [nzLoading]="isDownloading"
                    [disabled]="!password || password.length < 10"
                    (click)="downloadFile()">
                Download SDK
            </button>
        }

    </nz-card>
</div>